<template>
  <div class="basic-info-config">
    <div
      class="d-flex flex-column flex-lg-row justify-content-between mb-6 gap-3"
    >
      <h1 class="fs-14 text-semibold">Informações básicas</h1>
      <div class="d-flex gap-2">
        <snow-button variant="gray" text="Cancelar" @click="$router.go(-1)" />
        <snow-button text="Salvar" :disabled="!isValid" @click="onSubmit" />
      </div>
    </div>
    <div class="d-flex flex-lg-row flex-column gap-3">
      <snow-input-file
        v-model="form.picture"
        is-image
        dimensions="256 x 256"
        title="Imagem do produto"
      />

      <div class="col p-0">
        <div class="rounded-24 bg-2 p-6">
          <event-basic-information
            v-if="product.type_product == 'onsite_event'"
            :form="form"
          />

          <product-basic-information
            v-else
            :form="form"
            :errors="errors"
            :loading="loading"
            :product="product"
            :edit="true"
            @submit="onSubmit"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductBasicInformation from "@/components/product/BasicInformation";
import EventBasicInformation from "@/components/product/events/BasicInformation.vue";
import EditProductMixin from "@/mixins/editProduct.js";

export default {
  mixins: [EditProductMixin],
  components: { ProductBasicInformation, EventBasicInformation },
  computed: {
    isValid() {
      let requiredFields = ["name", "description", "category_id"];
      if (this.product.type_product == "onsite_event")
        requiredFields = [
          ...requiredFields,
          ...[
            "event_location",
            "event_address",
            "event_start_at",
            "event_end_at"
          ]
        ];
      return (
        !requiredFields.find(f => !this.form[f]) &&
        this.form.name.length <= 64 &&
        this.form.description.length <= 980
      );
    }
  },
  methods: {
    imageSupportingText(product) {
      return product.type_product == "onsite_event"
        ? "Imagem exibida no checkout e enviada no e-mail de confirmação de compra do ingresso."
        : "Imagem exibida no checkout para seus compradores.";
    }
  },
  mounted() {
    this.successLoad();
  }
};
</script>
